import React from 'react';
import moment from 'moment';

import { pendingOrdersDatePlacedFormat } from '../../../../lib/constants/date-time.constants';
import lang from '../../../../lib/language';
import { SORExtendedHoursMarker } from '../../../../lib/models/gateway/types';
import { getEndOfDayOrderExpirationDate } from '../../../../lib/store/reporting/trading/order-helpers';
import { TimeInForce } from '../../../../lib/store/reporting/types';

import styles from './styles.module.scss';

type Props = {
    expirationDate: string;
    expirationDateStyle: string | undefined;
    timeInForce: number;
    externalHours: SORExtendedHoursMarker;
    externalHoursStyle: string | undefined;
}

const PendingOrdersExpirationDate = ({
  expirationDate, timeInForce, externalHours, externalHoursStyle, expirationDateStyle,
}: Props) => (
  <>
    {(timeInForce === TimeInForce.GTC || timeInForce === TimeInForce.GoodTillDate)
     && (<div className={expirationDateStyle}>{moment.utc(expirationDate).format(pendingOrdersDatePlacedFormat)}</div>)}
    {(timeInForce === TimeInForce.Day || timeInForce === TimeInForce.ExtendedDay)
      && <div className={expirationDateStyle}>{getEndOfDayOrderExpirationDate()}</div>}
    {externalHours === 'X' && (
      <>
        <div className={externalHoursStyle}>{lang.commonMyAccountPendingOrdersExtHours()}</div>
      </>
    )}
  </>
);

export default PendingOrdersExpirationDate;
